module.exports = __webpack_public_path__ + "static/media/owner2_logo.dd5cc4db.png";